import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "symbol symbol-110px me-5" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_15 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_16 = { value: "DRAFT" }
const _hoisted_17 = { value: "PUBLISH" }
const _hoisted_18 = { value: "ARCHIVE" }
const _hoisted_19 = { value: "SCHEDULE" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "svg-icon svg-icon-3" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'blogs'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.translate('blogs')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.can('create', 'blogs'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('blogs-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('createNewBlog')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: blog }) => [
              _createTextVNode(_toDisplayString(blog.id), 1)
            ]),
            "cell-imageUrl": _withCtx(({ row: blog }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    alt: "Blog Image",
                    src: blog.imageUrl
                  }, null, 8, _hoisted_10)
                ])
              ])
            ]),
            "cell-titleEn": _withCtx(({ row: blog }) => [
              _createTextVNode(_toDisplayString(blog.titleEn), 1)
            ]),
            "cell-titleAr": _withCtx(({ row: blog }) => [
              _createTextVNode(_toDisplayString(blog.titleAr), 1)
            ]),
            "cell-authorName": _withCtx(({ row: blog }) => [
              _createTextVNode(_toDisplayString(blog.authorName), 1)
            ]),
            "cell-createdAt": _withCtx(({ row: blog }) => [
              _createTextVNode(_toDisplayString(blog.createdAt), 1)
            ]),
            "cell-publishedAt": _withCtx(({ row: blog }) => [
              _createTextVNode(_toDisplayString(blog.publishedAt), 1)
            ]),
            "cell-isHomepage": _withCtx(({ row: blog }) => [
              (blog.isHomepage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('Available')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.translate('Unavailable')), 1))
            ]),
            "cell-isActive": _withCtx(({ row: blog }) => [
              (blog.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-status": _withCtx(({ row: blog }) => [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select form-select-sm", {
              'text-success': blog.status === 'PUBLISH',
              'text-warning': blog.status === 'DRAFT',
              'text-muted': blog.status === 'ARCHIVE',
              'text-info': blog.status === 'SCHEDULE',
            }]),
                "onUpdate:modelValue": ($event: any) => ((blog.status) = $event),
                disabled: !_ctx.can('update', 'blogs'),
                onChange: ($event: any) => (_ctx.updateStatus(blog))
              }, [
                _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.translate('draft')), 1),
                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.translate('published')), 1),
                _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.translate('archive')), 1),
                _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.translate('scheduled')), 1)
              ], 42, _hoisted_15), [
                [_vModelSelect, blog.status]
              ])
            ]),
            "cell-actions": _withCtx(({ row: blog }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editBlog(blog.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_20),
              (_ctx.can('remove', 'blogs'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleBlogStatus(blog)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_22))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                onClick: _withModifiers(($event: any) => (_ctx.editSeo(blog.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_25, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen064.svg" })
                ])
              ], 8, _hoisted_24)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}